module.exports = __webpack_public_path__ + "img/example_kyc.0ab8fd9.webp";